function mtInitAll() {
  initReveal();
  initCountUp();
  initMarquesina();
  initHeroVideo();
}

document.addEventListener('DOMContentLoaded', mtInitAll);

/* El editor de temas de Shopify sustituye el HTML de una sección al cambiar
   un ajuste, sin recargar la página ni volver a disparar DOMContentLoaded.
   Sin esto, los textos con animación de aparición (.mt-reveal) se quedan
   invisibles (opacity:0) tras editar cualquier campo. */
document.addEventListener('shopify:section:load', mtInitAll);

function initHeroVideo() {
  var video = document.querySelector('.mt-hero-video');
  if (!video) return;
  var tryPlay = function () {
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  };
  tryPlay();
  video.addEventListener('canplay', tryPlay);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) tryPlay();
  });
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal, .mt-reveal-stagger');
  if (!els.length) return;
  var enEditor = window.Shopify && Shopify.designMode;
  if (enEditor || !('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function initCountUp() {
  var els = document.querySelectorAll('[data-mt-countup]');
  if (!els.length) return;
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches || (window.Shopify && Shopify.designMode);
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        observer.unobserve(el);
        var target = parseFloat(el.getAttribute('data-mt-countup')) || 0;
        var decimals = (el.getAttribute('data-mt-decimals') || '0') === '1' ? 1 : 0;
        if (prefersReduced) {
          el.textContent = target.toFixed(decimals);
          return;
        }
        var duration = 1400;
        var start = null;
        function step(ts) {
          if (start === null) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = (target * eased).toFixed(decimals);
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    },
    { threshold: 0.4 }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function initMarquesina() {
  var tracks = document.querySelectorAll('.mt-marquesina-track');
  if (!tracks.length) return;
  tracks.forEach(function (track) {
    if (track.dataset.mtDuped) return;
    track.dataset.mtDuped = '1';
    var clone = track.innerHTML;
    track.innerHTML += clone;
  });
}
